import { Container, Resolution, Scopes, type Token } from './inject';

/**
 * Creates a new TestBed instance, which is a container for
 * managing dependencies and facilitating dependency injection.
 *
 * @deprecated Prefer testing React hooks/components directly without dependency-injected classes or services.
 */
export function createTestBed() {
	return new TestBed();
}

class TestBed {
	public readonly resolution: Resolution;
	public readonly container: Container;

	constructor() {
		this.container = new Container();
		this.resolution = new Resolution(this.container);
	}

	public resolve<T>(dependencyToken: Token<T>) {
		return this.resolution.resolve(dependencyToken);
	}

	// Reason: Needed to make it possible to mock dependencies in tests. Else it'll be annoying af.
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	public mockRegister<T>(token: Token<any>, factory: T, lifeTime?: Scopes): void {
		this.container.addHotRegistration(token, factory, lifeTime);
	}

	public clearMocks() {
		this.container.clearHotRegistration();
	}
}
